import { ACTIVE_AUDIO_NODE_STORE } from '../globals';
export const isActiveAudioNode = (audioNode) => {
    return ACTIVE_AUDIO_NODE_STORE.has(audioNode);
};
//# sourceMappingURL=/build/es2018/helpers/is-active-audio-node.js.map